import { FC, useCallback, useState } from 'react'
import QueryUser from './QueryUser'
import UserForm from './Form'
import PreviewScreen from './PreviewScreen'
import { TSavedUserInfo } from './types'
import { ModalV2 } from '$components/Modal-V2'
import { modalContainer } from './styles.css'

type Props = {
  open: boolean
  onClose: VoidFunction
}

const AppUserCreate: FC<Props> = ({ open, onClose }) => {
  const [isQueryUserSuccess, setIsQueryUserSuccess] = useState(false)

  const [userId, setUserId] = useState('')

  const [userEmail, setUserEmail] = useState('')

  const [savedUserInfo, setSavedUserInfo] = useState<
    TSavedUserInfo | undefined
  >(undefined)

  const onQuerySuccess = useCallback((email: string, id?: string) => {
    setUserId(id ?? '')
    setIsQueryUserSuccess(true)
    setUserEmail(email)
  }, [])

  const onQueryAgain = useCallback(() => {
    setUserId('')
    setIsQueryUserSuccess(false)
  }, [])

  const onSuccess = useCallback((value: TSavedUserInfo) => {
    setSavedUserInfo(value)
  }, [])

  const _onClose = useCallback(() => {
    setUserId('')
    setUserEmail('')
    setIsQueryUserSuccess(false)
    setSavedUserInfo(undefined)
    onClose()
  }, [onClose])

  return (
    <ModalV2
      open={open}
      onClose={_onClose}
      contentClassName={modalContainer}
      contentStyle={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        maxWidth: 'none'
      }}
    >
      {!savedUserInfo && (
        <article>
          <article style={{ display: isQueryUserSuccess ? 'none' : 'block' }}>
            <QueryUser
              email={userEmail}
              onSuccess={onQuerySuccess}
              onBack={_onClose}
            />
          </article>

          <article
            style={{
              display: isQueryUserSuccess ? 'flex' : 'none',
              flexDirection: 'column',
              flex: 1
            }}
          >
            <UserForm
              userId={userId}
              onQueryAgain={onQueryAgain}
              onSuccess={onSuccess}
              email={userEmail}
            />
          </article>
        </article>
      )}

      {savedUserInfo && (
        <PreviewScreen
          userId={savedUserInfo.id}
          name={savedUserInfo.name}
          email={userEmail}
          password={userId ? '' : savedUserInfo.password}
          userType="service"
        />
      )}
    </ModalV2>
  )
}

export default AppUserCreate
